import { CategoryProductModelType } from '@teinor/erp/types/company/category/categoryProduct'
import { ProductLangModelType } from '@teinor/erp/types/company/product/productLang'
import { getLang } from '../../../../../../../utils/globals'

export const parseSelectedCategories = (selectedCategories?: CategoryProductModelType[]) => {
    const result: number[] = []
    if (selectedCategories) {
        for (const key in selectedCategories) {
            const category = selectedCategories[key]
            result.push(category.CategoryId)
        }
    }
    return result
}

export const getProductName = (data: ProductLangModelType[]) => {
    for (const element of data) {
        if (element.LangId === getLang()) {
            return element.name
        }
    }
    return ''
}